<!--
 * @Description: 跟进记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-14 13:53:43
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="DcCosOFbufollowUpRecord"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item name="customerNumber" :label="t('follow.customerNumber')">
              <a-input v-model:value="searchFrom.customerNumber" :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="customerName" :label="t('follow.customerName')">
              <a-input v-model:value="searchFrom.customerName" :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('common.department')">
              <CustomerAreaCascader type="search" appId="cos_ofbu" v-model:ids="searchFrom.deptIdList" />
            </dc-form-item>
            <dc-form-item name="dutyBy" :label="t('custom.followerName')">
              <user-select v-model:value="searchFrom.dutyBy" />
            </dc-form-item>
            <dc-form-item :label="t('follow.channel')">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="searchFrom.channelList"
                  appId="cos_ofbu"
                  paramCode="ofbu_source_channel"
                  style="width: 33%"
                  :placeholder="t('common.pleaseSelect')"
                  allowClear
                />
                <a-input
                  v-model:value="searchFrom.channelExplain"
                  :placeholder="t('common.pleaseInput')"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item :label="t('follow.cosId')">
              <a-input v-model:value="searchFrom.followRefId" :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('common.searchTime')">
              <a-input-group compact>
                <a-select v-model:value="searchFrom.timeType" style="width: 33%">
                  <a-select-option :value="0">{{ t('common.createTime') }}</a-select-option>
                  <a-select-option :value="1">{{ t('follow.fllowTime') }}</a-select-option>
                </a-select>
                <CosRangePicker
                  isOutputBeijingTime
                  v-model:startTime="searchFrom.startTime"
                  v-model:endTime="searchFrom.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <!-- <dc-form-item name="endTime" label="跟进日期">
              <cos-range-picker v-model:startTime="searchFrom.startTime" v-model:endTime="searchFrom.endTime" />
            </dc-form-item> -->
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd" v-permission="'ofbu_follow_add_btn'">
            {{ t('btn.add') }}
          </a-button>
          <ExportButton appId="cos_ofbu" taskType="409" :search="searchFrom" v-permission="'ofbu_follow_export_btn'">{{
            t('btn.export')
          }}</ExportButton>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'startTime'">
            <p>{{ text }}~{{ record.endTime }}</p>
          </template>
          <template v-if="column.dataIndex === 'process'">
            <EditorTableText :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button type="link" @click="handleEdit(record)" v-permission="'ofbu_follow_edit_btn'">
                {{ t('btn.edit') }}
              </a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'ofbu_follow_del_btn'"
                >{{ t('btn.del') }}
              </a-button>
              <a-button type="link" @click="handleCommit(record)" v-permission="'ofbu_follow_comment_btn'">
                {{ t('btn.comment') }}
              </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref, computed, reactive, onMounted } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { FbuFollowUpRecordParams, FbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import { fbuFollowRecordsList, followRecordsDelete } from '@/api/overseasSales/followUpManage'
import { customerPhaseEnum, customerAllStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useRouter } from 'vue-router'
import { listByParamCodes } from '@/api/common'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const tableRef = ref()
const router = useRouter()
const searchFrom = ref<FbuFollowUpRecordParams>({
  timeType: 0
})
const paramCodeData = reactive<{
  ofbu_follow_mode: []
  ofbu_follow_purpose: []
}>({
  ofbu_follow_mode: [], // 拜访方式
  ofbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_mode', 'ofbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const columns = computed(() => [
  {
    title: t('follow.customerName'),
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/ofbu/followUpRecord/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: t('follow.cosId'), dataIndex: 'followRefId' },
  { title: t('follow.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('follow.planTitle'), dataIndex: 'planTitle' },
  { title: t('follow.purpose'), dataIndex: 'fbuPurpose', dicData: paramCodeData.ofbu_follow_purpose },
  {
    title: t('custom.customerPhaseEnum'),
    dataIndex: 'stage',
    dicData: [{ label: t('enum.customerPhase1'), value: 1 }, ...customerPhaseEnum]
  }, // 1-线索阶段, 2-潜在客户阶段, 3-成交客户阶段
  { title: t('custom.customerStatus'), dataIndex: 'followStatus', dicData: customerAllStatusEnum },
  { title: t('custom.level'), dataIndex: 'amountLevel' },
  { title: t('follow.dutyByName'), dataIndex: 'dutyByName' },
  { title: t('follow.fllowTime'), dataIndex: 'startTime', width: 350, sorter: true },
  { title: t('follow.processDetail'), dataIndex: 'process', width: 450 },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', sorter: true, width: 160 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right',
    langWidth: {
      zh: 200,
      en: 220
    }
  }
])
const fetch = (params: FbuFollowUpRecordParams, callBack: (res: any) => void) => {
  fbuFollowRecordsList(params).then((res) => {
    callBack(res)
  })
}

const handleAdd = () => {
  router.push({
    path: '/ofbu/followUpRecord/add'
  })
}
const handleEdit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/ofbu/followUpRecord/edit',
    query: {
      id: record.id
    }
  })
}
const handleCommit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/ofbu/followUpRecord/commit',
    query: {
      id: record.id
    }
  })
}
const deleteRow = (record: FbuFollowUpRecordItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelete(record.id).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value.delFetch()
      })
    }
  })
}
// const success = (type = 'edit') => {
//   if (type === 'add') {
//     tableRef.value?.search()
//   } else {
//     tableRef.value?.fetch()
//   }
// }
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default {
  name: 'DcCosOFbuFollowUpRecord'
}
</script>
